<template>
    <nav class="category-switcher" aria-label="Blog categories">
        <div>
            <v-dropdown auto-hide>
                <button class="category-switcher__toggle">
                    {{ currentCategory.title }}
                    <span class="category-switcher__chevron">
                        <svg class="o-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="currentcolor">
                            <path d="M9.00518 10.2857C9.26425 10.2857 9.52331 10.1805 9.69947 9.98072L17.7202 1.64067C17.8963 1.46187 18 1.2305 18 0.967575C18 0.420679 17.5958 0 17.057 0C16.7979 0 16.5596 0.105172 16.3835 0.273449L8.44559 8.50832H9.5544L1.61658 0.273449C1.45078 0.105172 1.21244 0 0.943005 0C0.404144 0 0 0.420679 0 0.967575C0 1.2305 0.103627 1.46187 0.279793 1.65118L8.30052 9.98072C8.4974 10.1805 8.73574 10.2857 9.00518 10.2857Z" fill="currentcolor"/>
                        </svg>
                    </span>
                </button>
                <template #popper="{ hide }">
                    <ul
                        :id="`category-popover-${currentCategory.id || 0}`"
                        class="category-switcher__list"
                    >
                        <li v-for="category in sortedCategories" :key="category.id" class="category-switcher__list-item">
                            <button
                                class="category-switcher__link"
                                :class="{ 'category-switcher__link--active': category.id === currentCategory.id }"
                                @click="selectCategory(category); hide()"
                            >
                                {{ category.title }}
                            </button>
                        </li>
                    </ul>
                </template>
            </v-dropdown>
        </div>

        <ul
            :id="`category-popover-${currentCategory.id || 0}`"
            class="category-switcher__list"
            popover="auto"
        >
            <li v-for="category in sortedCategories" :key="category.id" class="category-switcher__list-item">
                <button
                    class="category-switcher__link"
                    :class="{ 'category-switcher__link--active': category.id === currentCategory.id }"
                    @click="selectCategory(category)"
                >
                    {{ category.title }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    categories: {
        type: Array,
        required: true,
    },
    selectedCategory: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(['category-selected']);

const sortedCategories = computed(() => {
    if (!props.categories) {
        return [];
    }
    return [...props.categories].sort((a, b) => a.title.localeCompare(b.title));
});

const currentCategory = computed(() => {
    return props.selectedCategory || sortedCategories.value[0] || { title: 'Categories', id: 0 };
});

const selectCategory = (category) => {
    emit('category-selected', category);
    document.getElementById(`category-popover-${currentCategory.value.id || 0}`)?.hidePopover();
};
</script>
